import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode | Array<ReactNode>;
  className?: string;
}

const ShadowContainer = ({ children, className }: Props) => {
  return (
    <div
      className={classNames(
        'rounded-3xl border border-grey-2 bg-white p-0 px-5 py-6 shadow-none md:px-14 md:py-10 md:shadow-md',
        className
      )}
    >
      {children}
    </div>
  );
};

export { ShadowContainer };
